import {
  ButtonProps,
  DialogActionsProps as MuiDialogActionsProps,
  DialogActions as MuiDialogDialogActions,
} from '@mildang/mui';
//TODO: use MDS Button
// import Button from 'components/molecules/Button';
import { Button } from '@mildang/mui';
import { ReactNode } from 'react';
import { useLingui } from '@lingui/react';
import { css, cx } from '@mildang/styled-system/css';
import { SystemStyleObject } from '@mildang/styled-system/types';
import { splitCssProps } from '@mildang/styled-system/jsx';

const rootStyle = css({
  '& > :not(:first-of-type)': {
    marginLeft: '8px',
  },
  borderRadius: '0 0 8px 8px',
});

export interface DialogFooterProps extends MuiDialogActionsProps {
  confirmButtonProps?: ButtonProps;
  cancelButtonProps?: ButtonProps;
  cancelButtonContent?: ReactNode;
  confirmButtonContent?: ReactNode;
  onCancel?: () => void | Promise<void>;
  onClick?: () => void | Promise<void>;
  panda?: SystemStyleObject;
}

const DialogFooter = (props: DialogFooterProps) => {
  const {
    children,
    onCancel,
    onClick,
    cancelButtonContent,
    confirmButtonContent,
    confirmButtonProps,
    cancelButtonProps,
    panda,
    className,
    ...others
  } = props;

  const { i18n } = useLingui();
  const [cssProps] = splitCssProps(others);
  const { ...styleProps } = cssProps;

  const defaultActions = (
    <>
      <Button onClick={onCancel} {...cancelButtonProps}>
        {cancelButtonContent || i18n.t({ message: '취소', id: '취소' })}
      </Button>
      <Button onClick={onClick} variant="contained" {...confirmButtonProps}>
        {confirmButtonContent || i18n.t({ message: '확인', id: '확인' })}
      </Button>
    </>
  );

  return (
    <MuiDialogDialogActions className={cx(rootStyle, css(styleProps, panda), className)} {...others}>
      {children ? children : defaultActions}
    </MuiDialogDialogActions>
  );
};

export default DialogFooter;
